import React from 'react'
import Button from 'lib/ui/Button'
import styled from 'styled-components'
import Icon from 'lib/ui/Icon'
import {JsonSave} from 'lib/JsonUpdateProvider'
import {NLPurchasePageTemplate} from 'Event/Marketplace/nl-purchase-page'
import AddRowDialog from 'organization/Marketplace/config/AddRowDialog'
import {useToggleArray} from 'lib/toggle'

export default function AddRowButton(props: {
  updateTemplate: JsonSave<NLPurchasePageTemplate>
}) {
  const {updateTemplate} = props

  const [showingAddRowDialog, toggleAddRowDialog] = useToggleArray()

  return (
    <>
      <AddRowDialog
        open={showingAddRowDialog}
        onClose={toggleAddRowDialog}
        updateTemplate={updateTemplate}
      />
      <Box>
        <StyledButton
          variant="contained"
          fullWidth
          onClick={toggleAddRowDialog}
          size="large"
          startIcon={<Icon className="fa-solid fa-circle-plus" />}
        >
          Add Row
        </StyledButton>
      </Box>
    </>
  )
}

const Box = styled.div`
  margin: 3rem 0;
  padding: ${(props) => `${props.theme.spacing[6]} ${props.theme.spacing[3]}`};
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledButton = styled(Button)`
  max-width: 300px;
  color: white;
  background-color: #1e4686;
  &:hover {
    background-color: #1e4686;
    opacity: 0.9;
  }
`
